import { useCallback, useState } from "react"

interface UseIdempotencyKeyResult {
  /** The key to send with the current attempt. */
  key: string
  /** Start a new attempt — call it once a create has come back. */
  reset: () => void
}

/**
 * One identifier per attempt, so every retry of that attempt carries it.
 *
 * Per attempt rather than per submit, because the retry is the submit that has
 * to match: a write that lost its reply may still have committed, and the
 * browser cannot tell that from one that never landed. An attempt ends when a
 * create comes back — keeping the key past that would replay the finished
 * project for a form the user has since edited.
 */
export const useIdempotencyKey = (): UseIdempotencyKeyResult => {
  const [key, setKey] = useState(() => crypto.randomUUID())
  const reset = useCallback(() => setKey(crypto.randomUUID()), [])

  return { key, reset }
}
